module.exports = __webpack_public_path__ + "img/3-01.66bc9182.png";